export { default as MeasuringTapeAltSolidIcon } from './MeasuringTapeAltSolidIcon';
